import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiArrowRight } from 'react-icons/fi';

export default function OrderSuccess() {
  return (
    <div className="min-h-screen bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <FiCheckCircle size={80} className="text-green-500 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'serif' }}>
            Order Successful!
          </h1>
          <p className="text-gray-400 text-lg mb-8">
            Thank you for your purchase. Your order has been confirmed and will be processed shortly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/collections"
              className="inline-flex items-center px-8 py-4 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105"
              style={{ backgroundColor: '#CF0F63' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#B00D56'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#CF0F63'}
            >
              Continue Shopping
              <FiArrowRight className="ml-2" size={20} />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-all duration-300 hover:scale-105"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
